import { ContactDetailsWizardActions } from './actions'
import { ContactDetailsWizardGetters } from './getters'
import { ContactDetailsWizardMutations } from './mutations'
import { ContactDetailsWizardState } from './state'

export const CONTACT_DETAILS_WIZARD_NAMESPACE = 'contactDetailsWizard'

export const ContactDetailsWizard = {
  actions: ContactDetailsWizardActions,
  getters: ContactDetailsWizardGetters,
  mutations: ContactDetailsWizardMutations,
  namespaced: true,
  state: ContactDetailsWizardState,
}
